"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=descriptor.js.map